import { sanlamDarkBlue } from 'Material-UI/colors';
import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import DashboardLayout from 'components/DashboardLayout';
import NotificationsBloc from 'components/NotificationsBloc';
import Faq from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions';
import { StyledShortBody } from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/styles';
import WelcomeHeader from 'containers/AUTODashboard/Header/WelcomeHeader';
import LastRefunds from 'containers/AMCDashboard/LastRefunds';
import MyContracts from 'containers/AMCDashboard/MyContracts';
import Services from 'containers/AMCDashboard/services';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import HeaderMRH from 'images/AMC-background.svg';
import {
  getFaq,
  getLastNotification,
  setNotificationRead,
  setAMCDetailsPageBreadcrumbsPath,
} from 'store/global/actions';
import {
  getLastNotificationAMCSelector,
  getAMCFaqSelector,
} from 'store/global/selectors';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { getFirstNameSelector } from 'store/user/selectors';
import { PRIVILEGES } from 'utils/globalConst';
import ActionButtons from 'containers/AMCDashboard/actionButtons';
import PAGES from 'routes/pages';
import { getContractsAMC } from 'store/contract/actions';
import { getRefundsAMC } from 'store/sinistre/actions';
import {
  getContractAMCSelector,
  getBeneficiariesSelector,
} from 'store/contract/selectors';
import {
  getAllRefundsAMCSelector,
  getLastRefund,
  getRefundAMCDetailsSelector,
} from 'store/sinistre/selectors';

const LAST_NOTIFICATION = {
  type: 'santé',
  id: 1,
  idApp: 'fake',
  action_title: 'fake',
  message: 'fake-message',
  title: 'fake-title',
  policyNumber: 'fake-policy-number',
  status: 'fake-status',
  read: 0,
};

const AMCDashboard = ({
  getLastNotification,
  lastNotification,
  setNotificationRead,
  setAMCDetailsPageBreadcrumbsPath,
  ...props
}: {
  intl: IntlShape;
  firstName: string;
  setAMCDetailsPageBreadcrumbsPath: Function;
  getLastNotification: Function;
  setNotificationRead: Function;
  lastNotification: {
    type: string;
    id: Number;
    idApp: string;
    action_title: string;
    message: string;
    title: string;
    policyNumber: string;
    status: string;
    read: boolean;
  };
  getFaq: Function;
  getContractsAMC: Function;
  getRefundsAMC: Function;
  faq: { question: string; code: string; id: number }[];
  refunds: any;
  refundDetails: any;
  contracts: any;
  beneficiaries: any;
  lastRefund: any;
}) => {
  const language = useSelector(getLocaleSelector);
  const { AMC } = PRIVILEGES;

  useEffect(() => {
    getLastNotification(AMC);
  }, [AMC, getLastNotification]);
  /* eslint-disable */
  useEffect(() => {
    props.getFaq(language);
    // eslint-disable-next-line
  }, [language]);
  useEffect(() => {
    props.getContractsAMC();
    props.getRefundsAMC({});
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <DashboardLayout
        MyContracts={<MyContracts contracts={props.contracts} setDetailsPageBreadcrumbsPath={setAMCDetailsPageBreadcrumbsPath} />}
        Faq={
          <Faq
            items={
              props.faq &&
              props.faq.map(
                (
                  item: { question: string; code: string; id: number },
                  index: number,
                ) => ({
                  title: (
                    <StyledShortBody
                      weight="bold"
                      color={sanlamDarkBlue}
                      key={index}
                    >
                      {item.question}
                    </StyledShortBody>
                  ),
                  path: PAGES.FAQ,
                  id: item.id,
                  code: item.code,
                  isFaq: true,
                  category: EVENT_CATEGORIES.AMC_ACCUEIL,
                  label: 'FAQ_' + ++index,
                }),
              )
            }
            GACategoryAllResponses={EVENT_CATEGORIES.AMC_ACCUEIL}
          />
        }
        LastSinistre={
          <LastRefunds
            lastRefund={props.lastRefund}
            refundDetails={props.refundDetails}
            setDetailsPageBreadcrumbsPath={setAMCDetailsPageBreadcrumbsPath}
          />
        }
        WelcomeHeader={<WelcomeHeader name={props.firstName} />}
        HeaderImage={HeaderMRH}
        ServicesBloc={<Services mdGrid={6} smGrid={6} />}
        NotificationsBloc={
          <NotificationsBloc
            message={
              LAST_NOTIFICATION?.message && LAST_NOTIFICATION.message
            }
            ignoreNotify={() =>
              setNotificationRead({
                id: LAST_NOTIFICATION.id,
                section: AMC,
                isRedirectTo: false,
              })
            }
            clickEvent={() =>
              setNotificationRead({
                id: LAST_NOTIFICATION.id,
                section: AMC,
              })
            }
          />
        }
        MenuItem={
          <ActionButtons
            setDetailsPageBreadcrumbsPath={setAMCDetailsPageBreadcrumbsPath}
          />
        }
      />
    </>
  );
};

const mapDispatchToProps = {
  getLastNotification,
  setNotificationRead,
  getFaq,
  setAMCDetailsPageBreadcrumbsPath,
  getContractsAMC,
  getRefundsAMC,
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    lastNotification: {
      type: string;
      id: Number;
      idApp: string;
      action_title: string;
      message: string;
      title: string;
      policyNumber: string;
      status: string;
      read: boolean;
    };
    firstName: string;
    faq: [];
    refunds: [];
    refundDetails: {};
    contracts: [];
    beneficiaries: [];
    lastRefund: {};
  }
>({
  firstName: getFirstNameSelector,
  lastNotification: getLastNotificationAMCSelector,
  faq: getAMCFaqSelector,
  refunds: getAllRefundsAMCSelector,
  refundDetails: getRefundAMCDetailsSelector,
  contracts: getContractAMCSelector,
  beneficiaries: getBeneficiariesSelector,
  lastRefund: getLastRefund,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AMCDashboard));
export { AMCDashboard };
